
<div class="cp-frame">
  <slot></slot>
  <!-- <div class="header"></div>
  <div class="center">
    <slot></slot>
  </div>
  <div class="frame-footer"></div> -->
</div>
